import { Maybe, Operation } from '../../../__generated__/globalTypes'

import {
  MinimalContactFragment,
  minimalContactFragmentString,
} from '../../fragments/__generated__/MinimalContactFragment'

import getPaginatedMinimalContactsRawString from '../GetPaginatedMinimalContacts.graphql'

const getPaginatedMinimalContactsString = [
  getPaginatedMinimalContactsRawString,
  minimalContactFragmentString,
].join('\n\n')

export type GetPaginatedMinimalContactsData = {
  paginatedContacts: {
    contacts: MinimalContactFragment[]
  }
}

export type GetPaginatedMinimalContactsVariables = {
  search?: Maybe<string>
  offset?: Maybe<number>
  limit?: Maybe<number>
}

export type GetPaginatedMinimalContacts = Operation<
  GetPaginatedMinimalContactsData,
  GetPaginatedMinimalContactsVariables
>

export const GetPaginatedMinimalContacts = ({
  search,
  offset,
  limit,
}: GetPaginatedMinimalContactsVariables = {}): GetPaginatedMinimalContacts => ({
  query: getPaginatedMinimalContactsString,
  variables: {
    search,
    offset,
    limit,
  },
})
